import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkedFilterButton',
  props: ['activeFilter', 'filterName'],
  setup(__props) {



const filtersStore = useFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activeFilter, (selectedFilter) => {
    return (_openBlock(), _createElementBlock("button", {
      type: "button",
      class: "serp__filters--marked-item-button q-btn q-btn-sm q-btn-light q-btn-sm q-me-2 q-mb-2 q-position-relative q-position-relative q-rounded-3 q-shadow-sm",
      key: selectedFilter
    }, [
      _createTextVNode(_toDisplayString(_unref(filtersStore).getFilterLabelByFilterName(__props.filterName)) + ": " + _toDisplayString(selectedFilter) + " ", 1),
      _createElementVNode("a", {
        class: "q-ms-1 q-stretched-link q-btn-close",
        onClick: _withModifiers(($event: any) => (_unref(filtersStore).updateFilter(__props.filterName, selectedFilter)), ["prevent"])
      }, null, 8, _hoisted_1)
    ]))
  }), 128))
}
}

})